import { CSSVar } from './helpers/CSSVar';

export const CurrentBackgroundColor = new CSSVar('current-background-color');
export const CalculatedPageHeight = new CSSVar('calculated-page-height');
